window.onload = function () {
  const product = document.querySelector('.shg-product');

  if (product) {
    const row = product.closest('.shg-row');

    if (row) {
      row.childNodes.forEach(child => {
        if (child.nodeType === 1) { // Ensures only element nodes are modified
          child.setAttribute('role', 'group');
          child.setAttribute('aria-label', 'product');
        }
      });
    }
  }
};
